module.exports = __webpack_public_path__ + "img/ective_230Ah.93c7dcd9.png";